<template>
  <div class="hint">
    <BasicText
      class="basic-hint"
      size="body-s"
      wrap
      color="neutral-500"
    >
      <slot>{{ hint }}</slot>
    </BasicText>
  </div>
</template>

<script setup lang="ts">
  import type { HintProps } from './BasicHint.types'

  defineProps<HintProps>()
</script>

<style lang="less">
  @import './BasicHint.less';
</style>
